import { useEffect, useRef } from 'react';

const CardService = ({ icon, image, title, isRight = false, children, id }) => {
  const divRef = useRef(null);
  const idParam = window.location.hash.slice(1);

  useEffect(() => {
    if (divRef.current.id === idParam) {
      window.scrollTo({ behavior: 'smooth', left: 0, top: divRef.current.offsetTop - 100 });
    }
  }, [idParam]);

  return (
    <div
      id={id}
      ref={divRef}
      className="border border-blue-200 rounded-xl p-6 mb-6 shadow-sm bg-white w-full max-w-[593px] max-h-[395px] h-full overflow-auto"
    >
      <div className="flex items-center mb-4 gap-4">
        <img src={icon} alt="icon" className="w-10 h-10 object-contain" />
        <h3 className="text-2xl font-bold text-blue-700">{title}</h3>
      </div>
      <div className="text-base text-gray-700">{children}</div>
    </div>
  );
};

export default CardService;
